import { Form } from "@remix-run/react"
import classNames from "classnames"

export function LogoutButton({
  ctaText,
  color,
  underline,
  className
}: {
  ctaText?: string
  color?: string
  underline?: boolean
  className?: string
}) {
  return (
    <div
      className={classNames(className, { "text-white": !color })}
      style={{ color: color }}
    >
      <Form method="post" action="/logout">
        <input type="hidden" name="form_type" value="customer_login" />
        <button className={classNames({ underline: underline })}>
          {ctaText ?? "Log Out"}
        </button>
      </Form>
    </div>
  )
}
